import React from 'react';

import {RemoveUser} from 'src/components/remove-user/remove-user';
import {Separator} from 'src/components/separator';
import {UserName} from 'src/components/user-name/user-name';
import {ColumnTypes, ColumnWidth} from 'src/modules/admin/constants';
import {UserAutosuggest} from 'src/modules/admin/user-role-management/user-autosuggest/user-autosuggest';
import {UserRoleCheckBox} from 'src/modules/admin/user-role-management/views/user-role-check-box';
import {Role} from 'src/openapi/models/Role';
import {User} from 'src/openapi/models/User';
import {UserRoles} from 'src/openapi/models/UserRoles';

import {Group} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Tooltip} from '@pb/kit-component-popups';
import {
    HorizontalPositionElement,
    PushNotification,
    VerticalPositionElement,
} from '@pb/kit-component-push-notification';
import Table, {Body, Cell, Head, Row} from '@pb/kit-component-table';
import {Typography} from '@pb/kit-component-typography';

type Props = {
    userRolesData: UserRoles[],
    onRemoveHandle: (email: string) => void,
    onSaveHandle: (userRoles: UserRoles) => void,
    onRoleChangeHandle: (email: string, role: string, checked: boolean) => void,
    onSelectedUser: (user: User) => void,
};

const NOTIFICATION_CONFIG = {
    horizontal: HorizontalPositionElement.RIGHT,
    vertical: VerticalPositionElement.BOTTOM,
};

export const UserRoleManagementView = (props: Props) => {
    const {
        userRolesData,
        onRemoveHandle,
        onSaveHandle,
        onRoleChangeHandle,
        onSelectedUser,
    } = props;

    return (
        <Group direction="v" style={{width: '50%'}} className="pt-xxl">
            <Typography variant="heading-level-5">
                <strong>
                    User Role Management
                </strong>
            </Typography>
            <Separator/>
            <UserAutosuggest onSelectedUser={onSelectedUser} userRolesData={userRolesData}/>
            <Table>
                <Head>
                    <Cell width={ColumnWidth[ColumnTypes.USER]}>User</Cell>
                    <Cell className="text-align_center" width={ColumnWidth[ColumnTypes.REVIEWER]}>Reviewer</Cell>
                    <Cell className="text-align_center" width={ColumnWidth[ColumnTypes.APPROVER]}>Approver</Cell>
                    <Cell className="text-align_center" width={ColumnWidth[ColumnTypes.ADMIN]}>Admin</Cell>
                    <Cell width="1rem"/>
                    <Cell width="1rem"/>
                </Head>
                <Body>
                    {userRolesData.map(userRoles => (
                        <Row key={userRoles.email}>
                            <Cell><UserName email={userRoles.email}/></Cell>
                            <Cell verticalAlign="middle">
                                <Group justify="center">
                                    <UserRoleCheckBox
                                        role={Role.ROLE_UDEDT_REVIEWER}
                                        userRoles={userRoles}
                                        onRoleChangeHandle={onRoleChangeHandle}
                                    />
                                </Group>
                            </Cell>
                            <Cell verticalAlign="middle">
                                <Group justify="center">
                                    <UserRoleCheckBox
                                        role={Role.ROLE_UDEDT_APPROVER}
                                        userRoles={userRoles}
                                        onRoleChangeHandle={onRoleChangeHandle}
                                    />
                                </Group>
                            </Cell>
                            <Cell verticalAlign="middle">
                                <Group justify="center">
                                    <UserRoleCheckBox
                                        role={Role.ROLE_UDEDT_ADMIN}
                                        userRoles={userRoles}
                                        onRoleChangeHandle={onRoleChangeHandle}
                                    />
                                </Group>
                            </Cell>
                            <Cell verticalAlign="middle" className="text-align_center">
                                <Tooltip
                                    anchor={({anchorRef}) => (
                                        <BasicIconButton
                                            ref={anchorRef}
                                            iconProps={{type: Icons.SAVE, size: Sizes.Size_19}}
                                            onClick={() => onSaveHandle(userRoles)}
                                            disabled={userRoles.roles.length === 0}
                                        />
                                    )}>
                                    Save
                                </Tooltip>
                            </Cell>
                            <Cell verticalAlign="middle" className="text-align_center">
                                <PushNotification anchorOrigin={NOTIFICATION_CONFIG}>
                                    <RemoveUser email={userRoles.email} onRemoveHandle={onRemoveHandle}/>
                                </PushNotification>
                            </Cell>
                        </Row>
                    ))}
                </Body>
            </Table>
        </Group>
    );
};
